
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from 'components/home/home';
import SetRating from 'components/set-rating/set-rating';
import ManigaSetNext from 'components/maniga-set-next/maniga-set-next';
import StickersPage from 'components/stickers/stickers-page';
import CollectionPage from 'components/collection/collection-page';

import './App.css';

function App() {
  return (
    <div className="App">
      {/* <Header /> */}
      <Routes>
        <Route index element={<CollectionPage />} />
        <Route path='stickers' element={<StickersPage />} />
        <Route path='set-rating' element={<SetRating />} />
        <Route path='maniga-set-next' element={<ManigaSetNext />} />
      </Routes>
    </div>
  );
}

export default App;
